export default __webpack_public_path__ + "static/media/new-msat-modal-1.5996f189.svg";